(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cc-drawer"] && !Shopify.designMode) return;
  try {
    document.querySelector('.button_ita').addEventListener('click', (e) => {
    e.preventDefault();
    Weglot.switchTo('it');
  });

  document.querySelector('.button_eng').addEventListener('click', (e) => {
    e.preventDefault();
    Weglot.switchTo('en');
  });
  } catch(e) { console.error(e); }
})();

})();
